import { render, staticRenderFns } from "./bulk-create.vue?vue&type=template&id=75933784&scoped=true&"
import script from "./bulk-create.vue?vue&type=script&lang=ts&"
export * from "./bulk-create.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-create.vue?vue&type=style&index=0&id=75933784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75933784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VPagination})
